import { render } from "./DraftShipment.vue?vue&type=template&id=6c3ddd2a"
import script from "./DraftShipment.vue?vue&type=script&lang=js"
export * from "./DraftShipment.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macmini/Sites/self-ship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__